<template>  
  <div>
		<v-layout>
			<v-flex md6>
        <h3>Estándares</h3>
			</v-flex>
			<v-flex md6>
        <v-btn color="primary" @click="() => { changeStatus(0); addItem()}" class="float-r">
          <v-icon>add</v-icon>
          <span>Agregar Estandár</span>
        </v-btn>
			</v-flex>
		</v-layout>

		<v-layout>
			<v-flex md12>
        <StTable :rows.sync="rows">
          <template v-slot:delete="props">
            <v-icon @click="askForDelete(props.item)" style="color:darkred">delete</v-icon>
          </template> 
          <template v-slot:edit="props">
            <v-icon @click="editItem(props.item)">edit</v-icon>
          </template> 
        </StTable>
			</v-flex>
		</v-layout>

		<v-dialog v-model="dialog" width="600">
			<v-card class="pa-40">
				<h3>Estándares</h3>
        <!-- class="mt-40" -->
        <br>
        <in-text v-model="selectedItem.name" label="Nombre del estándar" p_icon="edit"/>
        <div>
          <in-user
            :label="`Nombre del dueño`"
            :value.sync="selectedItem.owner"
            item_key="employee_name"
            value_key="id"
            p_icon="edit"
          />
        </div>
        <br>
        <in-text v-model="selectedItem.related_asi_area" label="Área" p_icon="edit"/>

        <in-calendar :date.sync="selectedItem.due_date" label="Fecha de Vencimiento" :required="true"/>
        <div class="mt-40" style="border-bottom: solid 1px lightgrey;padding-bottom:40px">
          <fs1-span style="float:left;margin-top:7px;">Seleccionar archivo</fs1-span>
          <label :for="`file-upload-st-${id}`" class="custom-file-upload2" style="float:right" :class="dark_t?'dark':''">
            <fs1-span>{{['Cargar', 'Cargando', 'Cargado'][fileStatus]}} </fs1-span>
            <v-icon small>{{['attach_file', 'hourglass_empty', 'check'][fileStatus]}}</v-icon>
            <input :id="`file-upload-st-${id}`" class="btn" type="file" @change="selectFile($event.target.files)">
          </label>
        </div>
        <br>
				<in-text v-model="selectedItem.bhp_url" label="Link Documento"/>
				<fs1 tag="p" style="color:darkred" v-if="selectedItem.bhp_url">La vinculación de documentos por medio de un link ignorará el archivo cargado en plataforma.</fs1>
				<br>
        <br>

				<div class="textAlignCenter">
					<v-btn color="secondary" @click="dialog = false">
						<v-icon>close</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary" @click="beforeSave" :disabled="!canSave">
						<v-icon class="mr-1">save</v-icon>
						<span>Guardar</span>
					</v-btn>
				</div>
		    <UserAddEmail :item.sync="selectedUser" :dialog.sync="dialogEmail"/>
			</v-card>
		</v-dialog>
		<v-dialog persistent v-model="deleteDialog" width="400">
			<v-card class="pa-20 textAlignCenter">
				<h3>¿Seguro desea eliminar el estandár "{{selectedItem.name}}"?</h3>
        <h5>Podrían haber Activos y/o repuestos asociados a este estándar</h5>
				<br>
				<div>
					<v-btn color="secondary" @click="deleteDialog = false">
						<v-icon>reply</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="deleteItem(selectedItem)">
						<v-icon>delete</v-icon>
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

  </div>	
</template>

<script>
import UserAddEmail from '@/components/admin/UserAddEmail.vue';
import StTable from '@/components/admin/tables/Standars.vue';
import { addStandards, editStandard } from '@/requests/ac';
import SimpleCrud from '@/components/mixins/simpleCrud/SimpleCrud';
import {v4 as uuid} from 'uuid';


export default {
  mixins: [ SimpleCrud ],
  components: { UserAddEmail, StTable },
  data() {
    return {
      id: uuid(),
      storeKey: 'standards',
      selectedUser: {file: null},
      dialogEmail: false,
      status: 0,
      
      search_user:'search-user',
    };
  },
  computed: {
    canSave(){
      return !!this.selectedItem.related_asi_area && !!this.selectedItem.name;
    },
    fileStatus(){
      return this.selectedItem.file
        ? (typeof this.selectedItem.file === 'string' ? 2 : this.status)
        : this.status; 
    },
    add() { return addStandards },
    edit() { return this.preEditStandard },
    defaultItem() { return JSON.parse(JSON.stringify({name: '', file: null}))},
    requestStatus() {return this.$store.getters.requestStatus},
    search_user_rqst(){return this.requestStatus.find(f => f.name === `${this.search_user}/a/all`)},
    search_user_rqst_rq(){return (this.search_user_rqst||{}).rq },
  },
  watch: {
    'selectedItem.owner'(val) {
      if (val) {
        const rq = this.search_user_rqst_rq;
        if (rq && rq.then) {
          rq.then(r => {
            if (r && r.results) {
              this.selectedUser = r.results.find(f => f.id === val);
              this.dialogEmail = this.selectedUser && !this.selectedUser.email;
            }
            return r
          })
        }
      }
    },
  },
  methods: {
    beforeSave(){ this.save() },
    editItem(item){
      this.changeStatus(0);
      this.selectedItem = {...item};
      this.dialog = true
    },
    editStandard,
    preEditStandard(row){
      const item = {...row};
      if (typeof item.file === 'string') delete item.file;
      return this.editStandard(item)
    },
    afterSave(row, selected, r) {
      row.file = r.file;
      row.link = r.link;
      row.onwer_username = r.onwer_username;
      row.owner = r.owner;
      row.owner_full_name = r.owner_full_name;
      row.due_date = r.due_date;
    },
    changeStatus(i){ this.status = i},
    selectFile(files) { // files no es un array por lo que sus proto funciones no aplican
      const file = files[0];
      const {changeStatus} = this;
      changeStatus(1);
      this.selectedItem.file = file;
      const reader = new FileReader();
      reader.onload = e => changeStatus(2);
      reader.readAsDataURL(file);
    }, // selectFile
  } // methods
};
</script>

<style scoped>
  .checkBoxContainer>.v-input{ margin: 0 }
</style>